/*
 * CookieTrackingControl (v1.2)
 * Copyright (c) 2019 Thomas Reichelt, storecoNN GmbH, www.store-connector.com
 * is released under the MIT License https://opensource.org/licenses/mit-license.php
 */
jQuery(document).ready(function () {

    (function ($) {

        /* Cookie Handling to save config for next visit */
        function cookieSet(name, value, settings) {
            var days = settings.cookie_expires;
            var path = settings.cookie_path;
            var domain = settings.cookie_domain;
            var ck_name = settings.cookie_suffix + name;

            var expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
            document.cookie = ck_name + '=' + value + '; Expires=' + expires.toUTCString() + '; Secure; SameSite=Strict; Path=' + path + '; Domain=' + domain;
        }

        function cookieDel(name, settings) {
            var path = settings.cookie_path;
            var domain = settings.cookie_domain;
            var ck_name = settings.cookie_suffix + name;

            document.cookie = ck_name + '=; Max-Age=0; Path=' + path + '; Domain=' + domain + '; SameSite=Strict; Secure';
        }

        function getCookie(name, settings) {
            var ck_name = settings.cookie_suffix + name;
            var b = document.cookie.match('(^|;)\\s*' + ck_name + '\\s*=\\s*([^;]+)');
            return b ? b.pop() : '';
        }

        function debugCookie() {
            return document.cookie.split("; ");
        }

        function statusCookie(name, settings) {
            var status = false;

            if (getCookie(name, settings) == 'true') status = true;

            // CHECK all data overview/details
            $.each(settings.services, function (keyn, item) {

                // CHECK all DATA from Single Services/Cookies
                $.each(item.services, function (keyn2, item2) {
                    if (keyn2 == name && item2.cookie_default == true && getCookie(name, settings) != 'false') status = true;
                });

            });

            return status;
        }

        function getCurrentPath() {
            var current_loc_path = location.href.replace(/[^/]*$/, '');
            return current_loc_path;
        }

        function doAction(this_obj, settings) {
            myObj = $(this_obj);
            __ctc_holder_obj = $(settings.content_object);

            // ============= SHOW DETAILS ====================
            if (myObj.data('action') == 'show-details') {
                __ctc_duration = settings.layout.animation_duration + 100;

                // hide overview
                __ctc_holder_obj.find('.__ctc-overview').addClass("__ctc-hide").removeClass("__ctc-show");
                setTimeout(function () {
                    __ctc_holder_obj.find('.__ctc-overview').addClass("__ctc-d-none");
                }, __ctc_duration);

                // show details
                setTimeout(function () {
                    __ctc_holder_obj.find('.__ctc-details').removeClass("__ctc-d-none").addClass("__ctc-show").removeClass("__ctc-hide");
                }, __ctc_duration);

            } else if (myObj.data('action') == 'hide-details') {
                __ctc_holder_obj = $(settings.content_object);

                // hide details
                __ctc_holder_obj.find('.__ctc-details').addClass("__ctc-hide").removeClass("__ctc-show");
                setTimeout(function () {
                    __ctc_holder_obj.find('.__ctc-details').addClass("__ctc-d-none");
                }, __ctc_duration);

                // show overview
                setTimeout(function () {
                    __ctc_holder_obj.find('.__ctc-overview').removeClass("__ctc-d-none").addClass("__ctc-show").removeClass("__ctc-hide");
                }, __ctc_duration);

            }


            // ============= SAVE DATA / COOKIE CONFIG =======
            if (myObj.data('action') == 'accept-all' || myObj.data('action') == 'save') {
                var accept_all = false;
                if (myObj.data('action') == 'accept-all') __ctc_holder_obj.find('.__ctc-cookie-data').prop('checked', true);

                // save status if ctc saved in the past(auto show/hide widget)
                cookieSet('stat', 'true', settings);

                // CHECK all data overview/details
                $.each(settings.services, function (keyn, item) {

                    // CHECK all DATA from Single Services/Cookies || serviceGroup_status == true
                    $.each(item.services, function (keyn2, item2) {
                        if (__ctc_holder_obj.find('input[name="serviceSingle[' + keyn2 + ']"]').is(':checked') == true) {
                            cookieSet(keyn2, 'true', settings);
                        } else {
                            cookieSet(keyn2, 'false', settings);
                        }
                    });

                });

                // Close Widget
                settings.content_object.trigger('update');
                if (settings.auto_close == true) $.fn.cookieTrackingControl('close');
                if (settings.site_refresh_onsave == true) location.reload();


                //console.log( debugCookie() );
            }

        }

        function listenStatus(this_obj, settings) {
            var jq_obj = $(this_obj);

            //console.log(jq_obj.attr('name'),jq_obj.data("type"),jq_obj.is(':checked'));

            // === CLICK ON GROUP active: set all services to checked
            if (jq_obj.data("type") == 'group') {
                if (jq_obj.is(':checked')) {
                    jq_obj.closest('.__ctc-group-services').find('.__ctc-cookie-data').prop('checked', true);
                    $('input[name="' + jq_obj.attr('name') + '"]:not(:checked).__ctc-cookie-data').trigger('click'); // also group element from overview/details
                } else {
                    jq_obj.closest('.__ctc-group-services').find('.__ctc-cookie-data').prop('checked', false);
                    $('input[name="' + jq_obj.attr('name') + '"]:checked.__ctc-cookie-data').trigger('click'); // also group element from overview/details
                }
            }


        }

        function createLayout(settings) {

            var obj_h = $(settings.content_object);

            // first check already build? or have to load?
            if ($(window).data('ctc_created') != '1') {
                //console.log(obj_h);

                obj_h.css('margin-left', '-10000px'); // protect popup content in background when created into dom
                obj_h.append('<div class="__ctc-holder"></div>');


                // ========== Build OVERVIEW LAYOUT
                obj_h.find('.__ctc-holder').append('<div class="__ctc-box"><div class="__ctc-overview __ctc-show"></div><div class="__ctc-details __ctc-d-none"></div></div>');

                obj_h.find('.__ctc-overview').append('<div class="__row"><div class="__ctc-header __col"></div><div class="__ctc-selection __col"></div><div class="__ctc-action __col"></div><div class="__ctc-footer __col"></div></div>');
                if (typeof settings.layout.overview_img !== 'undefined') obj_h.find('.__ctc-overview .__ctc-header').append('<img class="__ctc-image" src="' + settings.layout.overview_img + '" />');
                if (typeof settings.layout.overview_title !== 'undefined') obj_h.find('.__ctc-overview .__ctc-header').append('<span class="__ctc-title">' + settings.layout.overview_title + '</span>');
                if (typeof settings.layout.overview_desc !== 'undefined') obj_h.find('.__ctc-overview .__ctc-header').append('<span class="__ctc-desc">' + settings.layout.overview_desc + '</span>');

                $.each(settings.services, function (keyn, item) {
                    var disabled = '';
                    var checked = '';
                    if (keyn == 'essential') {
                        checked = 'checked';
                        disabled = 'disabled';
                    }

                    obj_h.find('.__ctc-overview .__ctc-selection').append('<input class="__ctc-cookie-data" id="tracking-' + keyn + '" type="checkbox" data-type="group" name="serviceGroup[' + keyn + ']" value="1" ' + disabled + ' ' + checked + '>');
                    obj_h.find('.__ctc-overview .__ctc-selection').append('<label class="__ctc_group_label" for="tracking-' + keyn + '">' + item.title + '</label>');
                });

                // Buttons
                obj_h.find('.__ctc-overview .__ctc-action').append('<a class="__ctc-btn __ctc-btn-default __ctc-btn-block __ctc-do-action" data-action="show-details">' + settings.layout.button_more_details + '</a>');
                obj_h.find('.__ctc-overview .__ctc-action').append('<a class="__ctc-btn __ctc-btn-default __ctc-btn-block __ctc-do-action" data-action="save">' + settings.layout.button_save + '</a>');
                obj_h.find('.__ctc-overview .__ctc-action').append('<a class="__ctc-btn __ctc-btn-primary __ctc-btn-block __ctc-do-action" data-action="accept-all">' + settings.layout.button_accept_all + '</a>');

                //obj_h.find('.__ctc-overview .__ctc-footer').append('<a class="__ctc-do-action" data-action="show-details">' + settings.layout.button_more_details + '</a>');
                //if (settings.layout.overview_text_footer != '') obj_h.find('.__ctc-overview .__ctc-footer').append('<span class="__ctc-footer-text">' + settings.layout.overview_text_footer + '</span>');


                // ========== Build DETAILS LAYOUT
                obj_h.find('.__ctc-details').append('<div class="__row"><div class="__ctc-header __col"></div><div class="__ctc-action __col"></div><div class="__ctc-selection __col"></div><div class="__ctc-footer __col"></div></div>');
                if (typeof settings.layout.overview_img !== 'undefined') obj_h.find('.__ctc-details .__ctc-header').append('<img class="__ctc-image" src="' + settings.layout.details_img + '" />');
                if (typeof settings.layout.overview_title !== 'undefined') obj_h.find('.__ctc-details .__ctc-header').append('<span class="__ctc-title">' + settings.layout.details_title + '</span>');
                if (typeof settings.layout.overview_desc !== 'undefined') obj_h.find('.__ctc-details .__ctc-header').append('<span class="__ctc-desc">' + settings.layout.details_desc + '</span>');

                // Buttons
                obj_h.find('.__ctc-details .__ctc-action').append('<a class="__ctc-btn __ctc-btn-primary __ctc-do-action __ctc-btn-block-mobile" data-action="accept-all">' + settings.layout.button_accept_all + '</a>');
                obj_h.find('.__ctc-details .__ctc-action').append('<a class="__ctc-btn __ctc-btn-default __ctc-do-action __ctc-btn-block-mobile" data-action="save">' + settings.layout.button_save + '</a>');
                obj_h.find('.__ctc-details .__ctc-action').append('<a class="__ctc-do-action __ctc-btn-block-mobile" data-action="hide-details">' + settings.layout.button_back + '</a>');


                $.each(settings.services, function (keyn, item) {
                    //console.log(keyn,item);
                    var checked = getCookie(keyn, settings) == 'true' ? 'checked' : '';
                    var disabled = '';
                    if (keyn == 'essential') {
                        checked = 'checked';
                        disabled = 'disabled';
                    }

                    obj_h.find('.__ctc-details .__ctc-selection').append('<div class="__ctc-group-services __ctc-service-' + keyn + '"></div>');

                    obj_h.find('.__ctc-details .__ctc-group-services.__ctc-service-' + keyn).append('<span class="__ctc-title"><input class="__ctc-cookie-data" id="details-tracking-' + keyn + '" type="checkbox" data-type="group" name="serviceGroup[' + keyn + ']" value="1" ' + checked + ' ' + disabled + '><label class="__ctc_group_label" for="details-tracking-' + keyn + '">' + item.title + ' (' + Object.keys(item.services).length + ')</label></span>');
                    obj_h.find('.__ctc-details .__ctc-group-services.__ctc-service-' + keyn).append('<span class="__ctc-desc">' + item.desc + '</span>');
                    obj_h.find('.__ctc-details .__ctc-group-services.__ctc-service-' + keyn).append('<div class="__ctc-group-services-details"></div>');

                    // all Single Services/Cookies
                    var childs_checked = false;
                    $.each(item.services, function (keyn2, item2) {
                        obj_h.find('.__ctc-details .__ctc-group-services.__ctc-service-' + keyn + ' .__ctc-group-services-details').append('<table class="__ctc-table-' + keyn2 + '"><tbody></tbody></table>');
                        my_table = obj_h.find('.__ctc-details .__ctc-group-services.__ctc-service-' + keyn + ' .__ctc-group-services-details table.__ctc-table-' + keyn2 + ' tbody');

                        var checked2 = getCookie(keyn2, settings) == 'true' ? 'checked' : '';
                        var disabled2 = '';
                        if (keyn == 'essential') {
                            checked2 = 'checked';
                            disabled2 = 'disabled';
                        }

                        // set groupService
                        if (checked2 == 'checked') childs_checked = true;

                        my_table.append('<tr><th>' + settings.layout.details_table_status + '</th><td><input class="__ctc-cookie-data" id="details-tracking-' + keyn2 + '" type="checkbox" data-type="single" name="serviceSingle[' + keyn2 + ']" value="1" ' + checked2 + ' ' + disabled2 + '><label class="__ctc_single_label" for="details-tracking-' + keyn2 + '">&nbsp;</label></tr>');
                        if (typeof item2.title !== 'undefined') my_table.append('<tr><th>' + settings.layout.details_table_title + '</th><td>' + item2.title + '</td></tr>');
                        if (typeof item2.owner !== 'undefined') my_table.append('<tr><th>' + settings.layout.details_table_owner + '</th><td>' + item2.owner + '</td></tr>');
                        if (typeof item2.reason !== 'undefined') my_table.append('<tr><th>' + settings.layout.details_table_reason + '</th><td>' + item2.reason + '</td></tr>');
                        if (typeof item2.cookie_host !== 'undefined') my_table.append('<tr><th>' + settings.layout.details_table_cookie_host + '</th><td>' + item2.cookie_host + '</td></tr>');
                        if (typeof item2.cookie_name !== 'undefined') my_table.append('<tr><th>' + settings.layout.details_table_cookie_name + '</th><td>' + item2.cookie_name + '</td></tr>');
                        if (typeof item2.cookie_lifetime !== 'undefined') my_table.append('<tr><th>' + settings.layout.details_table_cookie_lifetime + '</th><td>' + item2.cookie_lifetime + '</td></tr>');
                        if (typeof item2.url_dataprivacy !== 'undefined') my_table.append('<tr><th>' + settings.layout.details_table_url_dataprivacy + '</th><td>' + item2.url_dataprivacy + '</td></tr>');

                    });

                    // if any child is checked also check group
                    if (childs_checked == true) obj_h.find('.__ctc-holder input[name="serviceGroup[' + keyn + ']"]').prop('checked', true);

                });


                $(window).data('ctc_created', '1');
            }
        }


        var methods = {
            init: function (settings) {

                object_holder = this;

                // 20200210 - Fallback if holder-container not yet exists
                if ($(this).length == 0) {
                    selector = $(object_holder).selector;
                    $('body').append('<div id="' + selector.replace("#", "") + '"></div>');
                    object_holder = $('#' + selector.replace("#", ""));
                }

                var defaults = {
                    'content_object': object_holder,
                    'services': {
                        'essential': {
                            'title': 'Essential',
                            'desc': 'Essential cookies enable basic functions and are necessary for the proper functioning of the website.',
                            'services': {
                                'general': {
                                    'title': 'My Website',
                                    'owner': 'Owner of Website',
                                    'reason': 'Saves the attitudes of the visitors, who were selected in the cookie box as well as various other attitudes like eg. Show / hide contents.',
                                    'cookie_host': document.location.host,
                                    'cookie_name': 'website-cookie',
                                    'cookie_lifetime': '1 Year',
                                    'cookie_default': false,
                                    'url_dataprivacy': ''
                                }
                            }
                        }
                    },
                    'cookie_suffix': 'ctc__',
                    'cookie_path': '/',
                    'cookie_domain': document.location.host,
                    'cookie_expires': 365,
                    'site_refresh_onsave': true, /*might be a good idea to not loose initial first impression on statistic tools*/
                    'auto_show': true,  /*when initialized and cookie status not yet set, widget will auto shown*/
                    'auto_close': true,	/*when data saved/accepted auto close widget*/
                    'hide_on_click': false,	/*when "true" => click background or keyboard "esc" close widget*/
                    'show_button_settings': true, /*default button on every page for settings left-bottom*/
                    'css_path': getCurrentPath() + '/standalone.css',
                    'layout': {
                        'animation_duration': 500, // in ms
                        'overview_img': getCurrentPath() + '/assets/protect-shield.png',
                        'overview_title': 'WE USE COOKIES',
                        'overview_desc': 'We use cookies on our website. Some of them are essential while others help us improve this website and your experience.',
                        'overview_text_footer': '' /* optional */,
                        'details_img': getCurrentPath() + '/assets/protect-shield.png',
                        'details_title': 'SETTINGS',
                        'details_desc': 'Here is an overview of all cookies used. You can give your consent to whole categories or have more information displayed so that you can only select specific cookies.',
                        'details_table_status': 'Status',
                        'details_table_title': 'Name',
                        'details_table_owner': 'Owner',
                        'details_table_reason': 'Purpose',
                        'details_table_cookie_name': 'Cookie(s)',
                        'details_table_cookie_host': 'Domain',
                        'details_table_cookie_lifetime': 'Cookie Lifetime',
                        'details_table_url_dataprivacy': 'Data Privacy',
                        'button_more_details': 'More Details',
                        'button_back': 'back',
                        'button_accept_all': 'Accept All',
                        'button_save': 'Save',
                        'button_open_settings': 'Cookie Settings',

                    }
                };

                // Standardvalues of Plug-Ins and overwrite from User Optionens
                __ctc_options = $.extend(true, defaults, settings);

                // ========= INSERT CSS THEME INTO DOM, and check do only once
                if (__ctc_options.css_path.length > 0 && $(window).data('ctc_css_loaded') != '1') {
                    if (document.createStyleSheet) document.createStyleSheet(__ctc_options.css_path);
                    else $('head').append('<link rel="stylesheet" type="text/css" href="' + __ctc_options.css_path + '" />');
                    $(window).data('ctc_css_loaded', '1');
                }

                // ========= START CREATING LAYOUT =====
                // check if allow to auto-show
                isBot = /bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(navigator.userAgent);
                if (getCookie('stat', __ctc_options) != 'true' && __ctc_options.auto_show == true && isBot != true) createLayout(__ctc_options);

                // ========= LISTEN ACTIONS/SWITCHED OPTIONS for Services
                $(document).on('click', '.__ctc-do-action', function () {
                    doAction(this, __ctc_options);
                });

                // ========= LISTEN Changes Status GROUP/SINGLE =
                $(document).on('change', '.__ctc-cookie-data', function () {
                    listenStatus(this, __ctc_options);
                });

                // ========= Hide Widget on ESC,Click ===========
                if (__ctc_options.hide_on_click == true) {
                    $(document).keyup(function (e) {
                        if (e.keyCode === 27) $.fn.cookieTrackingControl('close');  // esc
                    });
                    __ctc_options.content_object.on('click', '.__ctc-holder', function (e) {
                        if (e.target != this) return;
                        $.fn.cookieTrackingControl('close');
                    });
                }

                // ========= Optional show Button Settings inline =
                if (__ctc_options.show_button_settings == true) {
                    __ctc_options.content_object.append('<div class="__ctc-btn-open-settings">' + settings.layout.button_open_settings + '</div>');
                    $(document).on('click', '.__ctc-btn-open-settings', function () {
                        $.fn.cookieTrackingControl('open');
                    });
                }

                // ================= END init ===================
            },
            open: function (content) {
                createLayout(__ctc_options);
                $('.__ctc-holder').removeClass('__ctc-hide-widget');
                __ctc_options.content_object.trigger('open');
            },
            close: function (content) {
                createLayout(__ctc_options);
                $('.__ctc-holder').addClass('__ctc-hide-widget');
                __ctc_options.content_object.trigger('close');
            },
            get_status: function (tracking_key) {
                return getCookie(tracking_key, __ctc_options) == 'true' ? true : false;
            }
        };

        $.fn.cookieTrackingControl = function (methodOrOptions) {

            if (window.location.pathname.startsWith("/impressum") || window.location.pathname.startsWith("/datenschutz")) {
                return;
            }

            if (methods[methodOrOptions]) {
                return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
            } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {

                // Default to "init"
                return methods.init.apply(this, arguments);
            } else {
                $.error('Method ' + methodOrOptions + ' does not exist on jQuery.cookieTrackingControl');
            }
        };


    })(jQuery);

});